import axios from "axios";
import { getToken } from "../services/Connector";

export const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(
  async (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      // config.headers["Access-Control-Allow-Origin"] = "*";
      // config.headers['Access-Control-Allow-Methods'] =  'GET, POST, OPTIONS, PUT, PATCH, DELETE';
      // config.headers["Access-Control-Allow-Headers"] = "x-access-token, Origin, X-Requested-With, Content-Type, Accept";
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if ((error.response.status === 401 || error.response.status === 401) && !originalRequest._retry) {
      originalRequest._retry = true;
      let refresh_token = sessionStorage.getItem("refresh_token");
      const access_token = await axios({
        method: "post",
        url: "https://api.textunited.com/authentication/api/RefreshToken",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          token: refresh_token,
        },
      });
      sessionStorage.setItem("token", access_token.data.AccessToken);
      sessionStorage.setItem("refresh_token", access_token.data.RefreshToken);
      const bearer = `Bearer ${access_token.data.AccessToken}`;
      console.log(bearer);
      axios.defaults.headers.common["Authorization"] = bearer;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);
